import React from 'react';
import { useTranslation } from 'react-i18next';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.log('call ErrorBoundary');
    console.log(error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.renderError) {
        // You can render any custom fallback UI
        return this.props.renderError()
      }
      return <ErrorMessage />;
    }

    return this.props.children;
  }
}

const ErrorMessage = () => {
  const { t } = useTranslation();
  return <h1>{t('Something went wrong.')}</h1>;
};
